/**
 * Created by hernanherreros on 2019-08-31
 */

import * as React from 'react'
import styled from 'styled-components'
import { Button, message } from 'antd'
import RatingHolder from './RatingHolder'
import Comment from './Comment'
import { answerQuestion } from '../../requests/feedback'

interface Props {
  question: any;
  onSuccess?: (questionUUID: string) => void;
  email: string;
}

export default function Question ({ question, onSuccess, email }: Props) {
  const [level, setLevel] = React.useState<number | undefined>(undefined)
  const [comment, setComment] = React.useState<string>('')
  const [loading, setLoading] = React.useState<boolean>(false)

  const isValid = () => {
    if (question.Type === 'level') {
      return !!level
    } else if (question.Type === 'text') {
      return !!comment
    } else if (question.Type === 'both') {
      return !!level && !!comment
    }
  }

  const submitForm = async () => {
    setLoading(true)

    try {
      await answerQuestion(null, {
        Comment: comment,
        QuestionUUID: question.UUID,
        Email: email,
        Level: level,
      })

      if (onSuccess) {
        onSuccess(question.UUID)
      }
      message.success('Enviada con éxito')
    } catch (e) {
     setLoading(false)
      message.error('Ocurrió un error. Intentalo más tarde.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container>
      <Title>{question.Title}</Title>
      {['level', 'both'].indexOf(question.Type) > -1 && <RatingHolder onSelect={setLevel} selected={level}/>}
      {['text', 'both'].indexOf(question.Type) > -1 && <Comment onChange={setComment}/>}
      <Button disabled={!isValid()} onClick={submitForm} loading={loading}>Enviar respuesta</Button>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
 
`

const Title = styled.h2`
  text-align: center;
`

